var _style, _path, _path2, _polyline, _path3, _path4, _polyline2, _polyline3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIskraftLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    width: 109,
    height: 21,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 168.2 28",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n    .st0 {\r\n        fill-rule: evenodd;\r\n        clip-rule: evenodd;\r\n        fill: #fff;\r\n    }\r\n\r\n    .st1 {\r\n        fill: #fff;\r\n    }\r\n    ")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0 mobile",
    d: "M2.1,7l8.1-2.9V1.7l-8.1,0L2.1,7 M9.9,26.2L10,6.1l-8,4l0,16.2H9.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M35.7,8.7C35.1,4.3,32,1.5,25.2,1.5c-6.1,0-10.5,1.9-10.5,7.2c0,9.6,14,7,14,10.8c0,1.2-1.4,1.8-3.4,1.8     c-0.8,0-1.5-0.2-2.2-0.6c-0.7-0.4-1.1-1.1-1.3-2h-7.6c0.2,4.5,4.4,7.6,10.8,7.6c6.7,0,11.3-2,11.3-7.8c0-9.1-14-6.8-14-10.5     c0-0.9,0.8-1.4,2.5-1.4c0.8,0,1.5,0.1,2.1,0.5c0.6,0.3,1,0.8,1.1,1.7H35.7"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "40.7,26.5 48.6,26.5 48.6,18.5 50.5,16.5 56.4,26.5 65.9,26.5 56.1,10.9 65,1.4 55.6,1.4 48.6,9.5     48.6,1.4 40.7,1.4 40.7,26.5 "
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M77,7.3h3.7c1.9,0,3.2,0.8,3.2,2.6c0,1.7-1.3,2.4-3.8,2.4H77V7.3 M79.7,17.7c3.7,0,4.3,1.1,4.3,4.3     c0,2.2,0.2,3.8,0.4,4.4h8.1v-0.8c-0.9,0-0.8-1.1-0.8-4.4c0-5-1.6-5.7-4.1-6.6c2.8-0.8,4.1-3.2,4.1-6.1c0-4.9-2.7-7.1-10.8-7.1H69.3     v25h8v-8.7H79.7z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M110.7,17.7h-5l2.5-9L110.7,17.7 M103.3,26.2l0.9-3.3h7.9l0.9,3.3h7.9l-8.7-25h-8.1l-8.7,25H103.3z"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "131.7,26.5 131.7,17.7 140.4,17.7 140.4,11.8 131.7,11.8 131.7,7.3 142.6,7.3 142.6,1.4 123.7,1.4     123.7,26.5 131.7,26.5 "
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "144.3,8 151.4,8 151.4,26.5 159.4,26.5 159.4,8 166.6,8 166.6,1.4 144.3,1.4 144.3,8 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIskraftLogo);
export default __webpack_public_path__ + "static/media/iskraftLogo.212dd35a.svg";
export { ForwardRef as ReactComponent };